import styled from 'styled-components'

import theme, { FontFamily } from '../../theme'

interface IWrapperProps {
  isEmpty?: boolean
}

const Wrapper = styled.span<IWrapperProps>`
  .ant-select {
    height: 100%;
    background: ${theme.colors.white};
  }

  .ant-select-clear {
    color: unset;
    opacity: 1;
    inset-inline-end: 4px;
    font-size: 14px;
    width: 14px;
    height: 14px;
  }

  .ant-input {
    font-family: ${FontFamily.primary};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: ${theme.colors.gray9};
  }

  .ant-input-affix-wrapper {
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.brandPrimary5} !important;
    border-radius: 2px;
    color: ${theme.colors.gray9};
    padding: ${(props) => (props.isEmpty ? '2px 4px' : '2px 22px 2px 4px')};
    height: 26px;
  }

  .ant-input-affix-wrapper-focused {
    box-shadow: none;
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border: none;
  }

  ${(props) => (props.isEmpty ? '' : '.ant-input-suffix { margin-inline-start: 0; }')}

  .ant-select-item-option-content {
    white-space: break-spaces;
    width: max-content;
  }
`

export { Wrapper }
